//
// TooltipSortItem.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";

var TooltipSortItem = createModule("BIRD::TooltipSortItem", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getLabel: [7],
        getSortedColumnName: [7],
        setSortDirection: [0,4],
        isPrimary: [2],
        getSortDirection: [4],
        getColumnName: [7],
        setPrimary: [0,2],
    },
    ,
    ,
]);
export default TooltipSortItem;
